<template lang="html">
  <div
    class="modal"
    :class="`${theClass} ${classes}`"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="closeModal"
        >
          <span aria-hidden="true"><v-icon name="close"/></span>
        </button>
        <div v-if="title" class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
        </div>
        <div class="modal-body" :class="bodyClass">
          <slot></slot>
        </div>
      </div>
    </div>
    <div class="modal-bg" @click="closeModal"></div>
  </div>
</template>

<script>
import jQuery from 'jquery/dist/jquery.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import { eventHub } from '@/utils/eventhub';

export default {
  props: {
    show: {
      default: false,
    },
    classes: {
      default: '',
    },
    bodyClass: {
      default: '',
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    Loading,
  },
  methods: {
    closeModal() {
      // this.show = false;
      this.$emit('onHide');
    },
  },
  computed: {
    theName() {
      return 'modal-' + this.name;
    },
    theClass() {
      // console.log(('.' + this.name));
      return this.theName + ' size-' + this.size;
    },
  },
  watch: {
    show(value) {
      if (value) {
        jQuery('.' + this.theName).modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        jQuery('.' + this.theName).modal('hide');
      }
      console.log('.' + this.theName);
    },
  },
  mounted() {
    const vm = this;
    jQuery('.' + vm.theName).on('shown.bs.modal', e => {
      vm.$emit('onShow');
    });
  },
};
</script>

<style lang="scss">
.modal {
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
  }
  .modal-body {
    padding: 0;
  }
  .modal-dialog {
    z-index: 2;
  }
  .modal-bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  &.size-1 {
    .modal-dialog {
      max-width: 420px;
    }
  }
  &.size-2 {
    .modal-dialog {
      max-width: 640px;
    }
  }
  &.size-3 {
    .modal-dialog {
      max-width: 960px;
    }
  }
  &.size-4 {
    .modal-dialog {
      max-width: 700px;
      width: 700px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/modal.vue